export default __webpack_public_path__ + "static/media/uploadDisable.933e9ec9.svg";